'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _dateTimeHelper = require('../../../../helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RailCardJourneyInfo = function RailCardJourneyInfo(props) {
  var label = props.label,
      time = props.time,
      country = props.country,
      titleLabelStyle = props.titleLabelStyle,
      titleValueStyle = props.titleValueStyle;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Departure' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: titleLabelStyle },
            label + ': ' + country
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: titleValueStyle },
            _dateTimeHelper2.default.getDate(time)
          )
        )
      )
    )
  );
};

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(RailCardJourneyInfo);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardJourneyInfo.jsx
// module id = 1548
// module chunks = 0